exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-19-wrapper[data-v-1a4441f1]{width:255px;padding-bottom:10px}.bottom-border[data-v-1a4441f1]{width:calc(100% + 3px);margin-bottom:-2px;margin-top:10px;margin-left:-1px;color:#fff;padding:2px;text-align:center;font-size:12px}.listing-img[data-v-1a4441f1]{width:38px;height:38px;border-radius:50%;display:inline-block}", ""]);

// exports
